module.exports = __webpack_public_path__ + "img/envelope-open.430b79e2.png";